
import React, { Component } from 'react';
import Iframe from './_NewIframe';

const styles = {
  iframeStyle: {
    border: '0',
  },
  wrapStyle: {
    padding: '0',
    overflow: 'hidden',
    float: 'center'
  },
  parentStyle: {
    textAlign: 'center'
  },
  resultStyle: {
    borderLeft: '1px solid grey',
    float: 'left',
    height: '100%',
    textAlign: 'center'
  }
}

class ResultComponent extends Component {
  constructor() {
    super()
    this.state = {}
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.width !== this.props.width) {
      window.setTimeout(this.updateDimensions, 10);
    }
  }
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
  render() {
    const key = JSON.stringify(Math.random()).slice(2);
    const { resultStyle } = styles;
    const resultStyleClone = JSON.parse(JSON.stringify(resultStyle));
    resultStyleClone.width = this.props.width + '%';
    resultStyleClone.borderLeft = this.props.width === 100 ? '' : '1px solid grey'
    return (
      <div style={resultStyleClone} ref="result">
        <div style={this.state.parentStyle}>
          <div style={this.state.renderWrapStyle}>
            <Iframe
              key={key}
              styleProps={this.state.renderIframeStyle}
              envelope={this.props.envelope}
            />
          </div>
        </div>
      </div>
    )
  }
  updateDimensions = () => {

    var resultEl = this.refs.result;
    const resWidth = resultEl.clientWidth;
    const resHeight = resultEl.clientHeight;
    const { iframeStyle, parentStyle, wrapStyle, resultStyle } = styles;
    const renderIframeStyle = JSON.parse(JSON.stringify(iframeStyle));
    const renderWrapStyle   = JSON.parse(JSON.stringify(wrapStyle));

    if (this.props.scale) {
      var parentHeight = resHeight,
          parentWidth  = resWidth;
      var width, height, scale;
      if (16 * parentHeight > 9 * parentWidth) {
        width = parentWidth;
        height = parentWidth * 9 / 16;
        renderWrapStyle.marginTop = ((parentHeight - height) / 2) + 'px';
      } else {
        height = parentHeight;
        width = parentHeight * 16 / 9;
        renderWrapStyle.marginLeft = ((parentWidth - width) / 2) + 'px';
      }
      scale = width / 1000;
      renderWrapStyle.height = height;
      renderWrapStyle.width = width;
      renderIframeStyle.height = 562.5;
      renderIframeStyle.width  = 1000;
      renderIframeStyle.MsTransform = 'scale(' + scale + ')'
      renderIframeStyle.MozTransform = 'scale(' + scale + ')'
      renderIframeStyle.OTransform = 'scale(' + scale + ')'
      renderIframeStyle.WebkitTransform = 'scale(' + scale + ')'
      renderIframeStyle.transform = 'scale(' + scale + ')'
      renderIframeStyle.MsTransformOrigin = '0 0'
      renderIframeStyle.MozTransformOrigin = '0 0'
      renderIframeStyle.OTransformOrigin = '0 0'
      renderIframeStyle.WebkitTransformOrigin = '0 0'
      renderIframeStyle.transformOrigin = '0 0';
    } else {
      renderIframeStyle.height = resHeight;
      renderIframeStyle.width = resWidth;
    }
    this.setState({ renderIframeStyle, renderWrapStyle, parentStyle, resultStyle })
  }
}

export default ResultComponent;



// WEBPACK FOOTER //
// ./src/_ResultComponent.js